<template>
  <div class="w-100">
    <div class="row">
      <div class="col-2">
        <b-form-group
            :label="$t('reports.filter.marketing_costs')"
            label-for="marketingCosts"
        >
          <b-form-input id="marketingCosts" type="number" v-model="marketingCosts"></b-form-input>
        </b-form-group>
      </div>
      <div class="col-2">
        <b-form-group
            :label="$t('reports.filter.country')"
            label-for="marketingCosts"
        >
          <multiselect
              v-model="country"
              :options="countries"
              :multiple="false"
              track-by="value"
              label="text">
          </multiselect>
        </b-form-group>
      </div>
      <div class="col-2">
        <b-form-group
            :label="$t('reports.filter.date_from')"
            label-for="dateFrom"
        >
          <date-range-picker v-model="dateFrom"
                             :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                             style="width: 100%;"
                             :singleDatePicker="true"
                             :time-picker="false"
                             :ranges="false"
                             :autoApply="true"
                             :opens="'right'">
            <template v-slot:input="picker" style="min-width: 350px;">
              <CalendarPlaceholder :date="picker.startDate" placeholder="reports.filter.calendar_placeholder"></CalendarPlaceholder>
            </template>
          </date-range-picker>
        </b-form-group>
      </div>
      <div class="col-2">
        <b-form-group
            :label="$t('reports.filter.date_from')"
            label-for="dateFrom"
        >
          <date-range-picker v-model="dateTo"
                             :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                             style="width: 100%;"
                             :singleDatePicker="true"
                             :time-picker="false"
                             :ranges="false"
                             :autoApply="true"
                             :opens="'right'">
            <template v-slot:input="picker" style="min-width: 350px;">
              <CalendarPlaceholder :date="picker.startDate" placeholder="reports.filter.calendar_placeholder"></CalendarPlaceholder>
            </template>
          </date-range-picker>
        </b-form-group>
      </div>
      <div class="col-2 d-flex align-items-end mb-3">
        <b-button class="btn" variant="secondary" @click="clearFilters">{{ $t('reports.btn.clear') }}</b-button>
        <b-button class="btn ml-2" variant="primary" @click="getReport">{{ $t('reports.btn.apply') }}</b-button>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <b-card
            no-body
            border-variant="secondary"
            :header="$t('title.report.management')"
            header-bg-variant="success"
            header-text-variant="white"
            align="left"
        >
          <table v-if="management" class="table table-striped mb-0">
            <tbody>
              <tr>
                <td class="font-weight-bolder">{{ $t('table.report.management.registrations') }}</td>
                <td>{{ management.registrations }}</td>
              </tr>
              <tr>
                <td class="font-weight-bolder">{{ $t('table.report.management.registrations_with_deposit') }}</td>
                <td>{{ management.registrationsWithDeposit }}</td>
              </tr>
              <tr>
                <td class="font-weight-bolder">{{ $t('table.report.management.cpl') }}</td>
                <td>{{ management.cpl }}</td>
              </tr>
              <tr>
                <td class="font-weight-bolder">{{ $t('table.report.management.cpa') }}</td>
                <td>{{ management.cpa }}</td>
              </tr>
            </tbody>
          </table>

          <small v-if="!management" class="d-flex justify-content-center align-items-center form-text text-muted p-5">
            {{ $t('table.report.management.btn.set_marketing_costs_value') }}
          </small>

          <div class="spinner-wrapper" v-else-if="isBusy">
            <b-spinner></b-spinner>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import DateRangePicker from "../../../components/DateRangePicker/components/DateRangePicker";
import Multiselect from "vue-multiselect";
import moment from "moment";
import CalendarPlaceholder from "./CalendarPlaceholder";

export default {
  components: {
    Multiselect,
    DateRangePicker,
    CalendarPlaceholder
  },
  data() {
    return {
      marketingCosts: null,
      country: null,
      dateFrom: {
        startDate: null
      },
      dateTo: {
        startDate: null
      }
    }
  },
  computed: {
    ...mapState({
      management: (state) => state.reports.management,
      isBusy: (state) => state.reports.isBusy
    }),
    countries: function () {
      const countries = this.$store.getters['root/country'].map(country => {
        return {
          value: country.key,
          text: country.label
        }
      });

      return countries;
    },
  },
  beforeDestroy() {
    this.$store.commit('reports/setManagement', null);
  },
  methods: {
    clearFilters() {
      this.marketingCosts = null;
      this.country = null;
      this.dateFrom = { startDate: null };
      this.dateTo = { startDate: null };

      this.getReport();
    },
    getReport() {
      if(this.marketingCosts) {
        this.$store.commit('reports/setManagement', null);

        const date = {
          marketingCosts: this.marketingCosts,
          country: this.country ? this.country.value : null,
          dateFrom: this.dateFrom.startDate ? moment(this.dateFrom.startDate).format('YYYY-MM-DD') : null,
          dateTo: this.dateTo.startDate ? moment(this.dateTo.startDate).format('YYYY-MM-DD') : null
        }

        this.$store.dispatch('reports/getManagementReport', date);
      }
    }
  }
}
</script>
